export default __webpack_public_path__ + "static/media/bg-featured-race.a6811e80.png";